import { DARK_THEME } from '../constants'
import {handleActions} from 'redux-actions';

export const dark = handleActions({
    [DARK_THEME]: (state) =>(!state)
},false);
